export function Search(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4854 10.2427C20.4854 4.5858 15.8996 0 10.2427 0C4.5858 0 0 4.5858 0 10.2427C0 15.8996 4.5858 20.4854 10.2427 20.4854L10.6011 20.4792C12.7452 20.4053 14.7739 19.6695 16.4485 18.392L16.5801 18.2862L21.9429 23.6471L22.0466 23.7391C22.5332 24.118 23.2162 24.0779 23.6471 23.6471L23.7349 23.5492L23.8155 23.4363C24.1086 22.9708 24.0525 22.3483 23.6471 21.9429L18.2862 16.5801L18.392 16.4485C19.7404 14.6809 20.4854 12.5187 20.4854 10.2427ZM2.41004 10.2427C2.41004 5.91683 5.91683 2.41004 10.2427 2.41004C14.5685 2.41004 18.0753 5.91683 18.0753 10.2427C18.0753 14.5685 14.5685 18.0753 10.2427 18.0753C5.91683 18.0753 2.41004 14.5685 2.41004 10.2427Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
